/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * Get a generated component set path to the chosen screen.
 * @param {string} screenPath The web path for the component set screen (must start with '/').
 * @param {string} setWebpath Substitute :setWebpath with the real ID (webpath).
 * @export
 * @returns {string} A generated organisation path for the chosen screen.
 */
export const getComponentSetPath = (screenPath: string, setWebpath?: string): string => {
  if (setWebpath) {
    return `/${setWebpath}${screenPath}`;
  }

  // Used for router
  return `/:setWebpath${screenPath}`;
};
